/** @format */

import {ButtonBase, TableBody, useMediaQuery, Link} from '@mui/material';

import {useTranslation} from 'react-i18next';

import theme from 'theme';

import {useMixpanelContext} from 'contexts/MixpanelContext';

import {ReportTableRowData} from '../../types';
import {ButtonCell, StyledTable, StyledTableCell, StyledTableRow, tableRowClasses} from './styles';

import {ReportFileFormat} from '../../../Report/types';

interface Props {
  data: ReportTableRowData[];
}

const ReportsTable = ({data}: Props) => {
  const {t} = useTranslation();
  const {mixpanel} = useMixpanelContext();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClick = async (url: string, fileFormat: ReportFileFormat, share: boolean) => {
    mixpanel.track('click_report_download_link', {format: fileFormat});

    if (!isMobile) return;
    if (!share) return;
    if (!navigator.share) return;

    await navigator.share({
      title: 'AdSensor',
      text: t('Отчёт AdSensor', 'Отчёт AdSensor') || '',
      url,
    });
  };

  return (
    <StyledTable data-testid='reports-table'>
      <TableBody>
        {data.map(row => (
          <StyledTableRow key={row.date}>
            <StyledTableCell>{row.date}</StyledTableCell>
            <ButtonCell>
              <ButtonBase
                className={tableRowClasses.styledButton}
                component={Link}
                href={row.pdfUrl}
                target='_blank'
                rel='noopener noreferrer'
                onClick={() => handleClick(row.pdfUrl, 'pdf', false)}
              >
                PDF
              </ButtonBase>
            </ButtonCell>
            <ButtonCell>
              <ButtonBase
                className={tableRowClasses.styledButton}
                component={Link}
                href={row.xlsxUrl}
                target='_blank'
                rel='noopener noreferrer'
                onClick={() => handleClick(row.xlsxUrl, 'xlsx', true)}
              >
                Excel
              </ButtonBase>
            </ButtonCell>
            <ButtonCell>
              <ButtonBase
                className={tableRowClasses.styledButton}
                component={Link}
                href={row.htmlUrl}
                target='_blank'
                rel='noopener noreferrer'
                onClick={() => handleClick(row.htmlUrl, 'html', true)}
              >
                HTML
              </ButtonBase>
            </ButtonCell>
          </StyledTableRow>
        ))}
      </TableBody>
    </StyledTable>
  );
};

export {ReportsTable};
